import type { ScratchVm } from "./scratch-editor";

const successful = new WeakMap<ScratchVm, Map<string, string>>();

export const aiRequestKey = (userId: string, projectId: string | undefined, action: string, prompt: string,
    targetId?: string): string => JSON.stringify([userId, projectId, action, prompt.trim(), targetId]);

export const wasAiRequestSuccessful = (vm: ScratchVm, key: string, context: object): boolean =>
    successful.get(vm)?.get(key) === JSON.stringify(context);

export const rememberAiSuccess = (vm: ScratchVm, key: string, context: object): void => {
    let requests = successful.get(vm);
    if (!requests) {
        requests = new Map();
        successful.set(vm, requests);
    }
    requests.set(key, JSON.stringify(context));
};

export const clearAiSuccess = (vm: ScratchVm): void => {
    successful.delete(vm);
};
